import React, { useState, useCallback, useEffect } from "react";
import { Container, Label } from "./styles";

import { Dropdown } from "semantic-ui-react";

const InputSelector = props => {
  const [data, setData] = useState(props.value || "");
  const [dataSearch, setDataSearch] = useState("");

  const handleCollabChange = useCallback((e, { options, value }) => {
    const text = options?.find(option => option.value === value)?.text || "";
    setData(value);
    setDataSearch(text);

    if (props.handleChange) {
      props.handleChange(value);
    }
  }, []);

  const handleDataSearchChange = useCallback(e => {
    const search = e.target.value;

    setDataSearch(search);
  });

  return (
    <Container>
      <div>
        {!props?.noLabel &&
          (<Label>{props?.customLabel}</Label> || (
            <Label>Selecione a opção</Label>
          ))}
        <Dropdown
          placeholder={props?.placeholder || "Selecione uma opção"}
          fluid
          search
          selection
          options={props.options}
          onChange={handleCollabChange}
          searchQuery={dataSearch}
          onSearchChange={handleDataSearchChange}
          value={data}
          clearable
        />
      </div>
    </Container>
  );
};

export default InputSelector;
